export interface Application {
    name: string;
    url: string;
    urlHelp: string;
    iconSmall: string;
    iconLarge: string;
    enabled: boolean;
    home: boolean;
    access_key: ApplicationAccessKey;
    shortcuts: ApplicationShortcut[];
    description: string;
}

export interface ApplicationShortcut {
    name: string;
    url?: string;
}

export enum ApplicationAccessKey {
    BUSINESS = 'business',
    CAMPAIGNS = 'campaigns',
    ANALYTICS = 'analytics',
    MERCHANDISING = 'merchandising',
    RETAILER_TOOLS = 'retailer_tools',
    SHOPPER_SUPPORT = 'shopper_support'
}
